// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"fd941444","787":"2e2c38c8","955":"056679c5"}[chunkId] + ".chunk.js";
};